import { useFlagsmith } from "@flagsmith/flagsmith/react";

/**
 * Custom hook for accessing flags utilities provided by Flagsmith.
 * @returns {object} Flags utilities from Flagsmith.
 */
const useFlagsUtilities = () => useFlagsmith();

export default useFlagsUtilities;
